import Replicas from "pages/Replicas";

const ReplicasWIP = () => {
  return <Replicas includeWIP />;
};

export default ReplicasWIP;
